module.exports = __webpack_public_path__ + "static/heavy_royal1-cb148f145877aab54f6e404418b10ab4.jpg";